import React from "react"

const IntersectionObserverPolyfill = ({
  component: Component = "div",
  ...restProps
}) => <Component {...restProps} />

export default IntersectionObserverPolyfill
